export default __webpack_public_path__ + "static/media/500.14d66db2.png";